import { render, staticRenderFns } from "./mail-notification.vue?vue&type=template&id=0b0bd7fb"
import script from "./mail-notification.vue?vue&type=script&lang=js"
export * from "./mail-notification.vue?vue&type=script&lang=js"
import style0 from "./mail-notification.vue?vue&type=style&index=0&id=0b0bd7fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports